export default {
  'noDataText': 'Sin datos disponibles'
};
